import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/frown-open': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM248 456c110.3 0 200-89.7 200-200s-89.7-200-200-200-200 89.7-200 200 89.7 200 200 200zM200 208c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zM328 176c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM248 288c35.6 0 88.8 21.3 95.8 61.2 2 11.8-9.1 21.6-20.5 18.1-31.2-9.6-59.4-15.3-75.3-15.3s-44.1 5.7-75.3 15.3c-11.5 3.4-22.5-6.3-20.5-18.1 7-39.9 60.2-61.2 95.8-61.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/frown-open.js
// module id = 1743
// module chunks = 0